import Vue from 'vue';
import App from './App.vue';
/* eslint-disable */
import sensors from './plugins/sensorsData'
/* eslint-enable */
import router from './router';
import store from './store';
import './registerServiceWorker';
import axios from '@/plugins/axios/index';
import VueBus from 'vue-bus';
import VModal from 'vue-js-modal';
import Moment from '@/plugins/moment.js';
import LayoutComponents from '@/components/layout/index.js';
import GlobalComponents from '@/components/global/index.js';
import Filters from '@/filters/index.js';
import directives from '@/directives/index.js';
import ElementUI from 'element-ui';
import utils from '@/utils/index.js';
import '@/assets/style/index.scss';

// 注册全局layout组件
Vue.use(LayoutComponents);
// 注册自定义全局组件
Object.keys(GlobalComponents).forEach((compName) => Vue.component(compName, GlobalComponents[compName]));
// 注册全局自定义filter
Object.keys(Filters).forEach((key) => Vue.filter(key, Filters[key]));
// 注册全局自定义directive
Object.keys(directives).forEach((key) => Vue.directive(key, directives[key]));

Vue.use(VueBus);
Vue.use(VModal);
Vue.use(ElementUI);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$mt = Moment;
Vue.prototype.$ = utils;
Vue.prototype.$bc = new BroadcastChannel('laihua');
Vue.prototype.$sensors = sensors;

var vue = new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');

//屏蔽文件打开
document.addEventListener(
  'drop',
  function(e) {
    e.stopPropagation();
    e.preventDefault();
  },
  false
);
document.addEventListener(
  'dragover',
  function(e) {
    e.stopPropagation();
    e.preventDefault();
  },
  false
);
export default vue;
